import { createFileRoute } from '@tanstack/react-router';

import { MainLoadingLayout } from '@/_containers/layout/template/main-loading-layout';

export const Route = createFileRoute('/_private')({
  pendingComponent: MainLoadingLayout,
});
